import { render, staticRenderFns } from "./newToolbar.vue?vue&type=template&id=5e92e794&"
import script from "./newToolbar.vue?vue&type=script&lang=js&"
export * from "./newToolbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports